import { styled } from "@mui/material/styles";
import { PickersDay } from "@mui/x-date-pickers";

interface WeekDayProps {
  isFirst: boolean;
  isLast: boolean;
  isHoveredWeek: boolean;
}

const WeekDay = styled(PickersDay, {
  shouldForwardProp: (prop) => prop !== "selected" && prop !== "isFirst" && prop !== "isLast" && prop !== "isHoveredWeek",
})<WeekDayProps>(({ theme, selected, isFirst, isLast, isHoveredWeek }) => ({
  borderRadius: 0,
  margin: 0,
  paddingLeft: 20,
  paddingRight: 20,

  backgroundColor: theme.palette.transparent.pure,
  color: theme.palette.text.primary,

  ...(isHoveredWeek &&
    !selected && {
      backgroundColor: `${theme.palette.action.hover}`,
      borderRadius: 0,
      color: theme.palette.text.primary,
    }),

  ...(isHoveredWeek &&
    selected && {
      backgroundColor: `${theme.palette.primary.dark} !important`,
      color: `${theme.palette.surface.card} !important`,
      borderRadius: 0,
      "&.MuiButtonBase-root:hover": {
        backgroundColor: `${theme.palette.primary.dark} !important`,
        color: `${theme.palette.surface.card} !important`,
        borderRadius: 0,
      },
    }),

  ...(!isHoveredWeek &&
    selected && {
      backgroundColor: `${theme.palette.primary.main} !important`,
      color: `${theme.palette.surface.card} !important`,
      borderRadius: 0,
    }),

  ...(isFirst && {
    borderTopLeftRadius: theme.radius.full,
    borderBottomLeftRadius: theme.radius.full,
  }),

  ...(isLast && {
    borderTopRightRadius: theme.radius.full,
    borderBottomRightRadius: theme.radius.full,
  }),
}));

export default WeekDay;
